import UserImage from './UserImage';

export default UserImage;
